import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Modal from "react-modal";
import { ReactComponent as Close } from "../../atoms/icons/close-modal.svg";

const ModalInner = styled.div`
    position: relative;
`;

const ModalHeading = styled.h2`
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    margin: 0;
    padding: 20px 40px 20px 30px;
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: -0.6px;
    color: var(--color-primary);
`;

const Alert = styled.span`
    display: block;
    width: 22px;
    height: 22px;
    margin-right: 10px;
    border-radius: 50%;
    background: var(--color-primary);
    border: 1px solid #fff;
    font-size: 14px;
    line-height: 22px;
    color: #fff;
    text-align: center;
    min-width: 22px;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    border: none;
    background: none;
    padding: 0;
    outline: none;
    cursor: pointer;
    user-select: none;
    outline: none;
    box-shadow: none;

    &:focus,
    &:hover,
    &:active {
        outline: none;
        box-shadow: none;
    }

    svg {
        width: 30px;
        height: 30px;
    }
`;

const customStyles = {
    content: {
        top: "30%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        padding: "0",
        transform: "translate(-50%, -50%)",
        border: "none",
        borderRadius: "3px",
        width: "80%",
        maxWidth: "320px",
        maxHeight: "80%",
        boxShadow: "0 0 30px rgba(0, 0, 0, 0.15)",
    },
    overlay: { zIndex: 1000, backgroundColor: "transparent" },
    button: {
        background: "none",
    },
};

Modal.setAppElement("#meal-constructor");

function ErrorMessage(props) {
    const { modalIsOpen, message, closeErrorModal = null } = props;

    function closeModal() {
        if (closeErrorModal) closeErrorModal();
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            style={customStyles}
            onRequestClose={closeModal}
        >
            <ModalInner>
                <ModalHeading>
                    <Alert>!</Alert>
                    <span>{message}</span>
                </ModalHeading>
            </ModalInner>

            {closeErrorModal && (
                <CloseButton onClick={closeModal}>
                    <Close />
                </CloseButton>
            )}
        </Modal>
    );
}

ErrorMessage.propTypes = {
    message: PropTypes.string
};

export default ErrorMessage;
